export default "__VITE_ASSET__Dc7pi48c__"